// Change option selected
const label = document.querySelector('.dropdown__filter-selected');
const options = Array.from(document.querySelectorAll('.dropdown__select-option'));
const po_customCheckbox = document.querySelector('.dropdown__switch');
const po_hiddenTitle = document.querySelector('.hidden_title');
const po_customDropdown = document.querySelector('.po_custom-dropdown');
const po_showDropdown = document.getElementById('po_showDropdown');
const po_customMessage = document.getElementById('po_customMessage');

if (po_showDropdown) {
  po_showDropdown.addEventListener('change', () => {
    if (po_showDropdown.checked) {
      po_customDropdown.style.display = 'block';
      po_hiddenTitle.style.display = 'block';
    } else {
      po_customDropdown.style.display = 'none';
      po_hiddenTitle.style.display = 'none';
    }
  });
}

options.forEach((option) => {
  option.addEventListener('click', () => {
    label.textContent = option.textContent.trim();

    const img = option.querySelector('img');
    const imgSrc = img ? img.src : '';

    const selectedImage = document.querySelector('.dropdown__filter-selected img');

    if (selectedImage) {
      selectedImage.src = imgSrc;
    } else {
      const newImg = document.createElement('img');
      newImg.src = imgSrc;
      newImg.alt = option.textContent.trim();
      newImg.style.width = '40px';
      newImg.style.margin = '0 9px 0 0';

      label.prepend(newImg);
    }
    po_customCheckbox.value = option.textContent.trim();
    po_customMessage.value = option.textContent.trim();
    po_customCheckbox.checked = true;
  });
});

// Close dropdown onclick outside
document.addEventListener('click', (e) => {
  const toggle = document.querySelector('.dropdown__switch')
  const element = e.target

  if (element == toggle) return;

  const isDropdownChild = element.closest('.dropdown__filter')

  if (!isDropdownChild && toggle) {
    toggle.checked = false
  }
})

document.addEventListener('DOMContentLoaded', function() {
  const selectedCheckbox = document.querySelector('.dropdown__switch');
  const variantSelectors = document.querySelectorAll('select[data-variant-option-trigger]');
  const productNote = document.querySelectorAll('.product-note');
  variantSelectors.forEach(select => {
    select.addEventListener('change', function() {
      const selectedOptionText = this.value;
      const masterSelect = document.querySelector('select[data-master-select]');
      let selectedVariantId = null;

      for (let i = 0; i < masterSelect.options.length; i++) {
        const option = masterSelect.options[i];

        if (option.text.includes(selectedOptionText)) {
          selectedVariantId = option.value;
          break;
        }
      }

      if (selectedVariantId) {
        masterSelect.value = selectedVariantId;

        productNote.forEach(note => {
          note.style.display = 'block';
        });

        updateVariantInformation(selectedVariantId);

      }
    });
  });
  if (selectedCheckbox) {
    selectedCheckbox.addEventListener('change', function() {
      const customMasterSelect = document.querySelector('select[data-master-select]');
      const productNotes = document.querySelectorAll('.product-note');
      const selectedOptionText = this.value;
      let selectedVariantId = null;

      for (let i = 0; i < customMasterSelect.options.length; i++) {
        const option = customMasterSelect.options[i];

        if (option.text.includes(selectedOptionText)) {
          selectedVariantId = option.value;
          break;
        }
      }

      if (selectedVariantId) {
        customMasterSelect.value = selectedVariantId;

        productNotes.forEach(note => {
          note.style.display = 'block';
        });

        // updateVariantInformation(selectedVariantId);
      } else {
        productNotes.forEach(note => {
          // note.style.display = 'none';
        });
      }
    });
  }

  function updateVariantInformation(variantId) {
    const variantInfo = fetchVariantDetails(variantId);
    const variantImage = document.querySelector('.variant-image');
    const variantPrice = document.querySelector('.variant-price');
    if (variantInfo) {
      variantImage.src = variantInfo.imageUrl;
      variantPrice.textContent = variantInfo.price;
    }
  }

  function fetchVariantDetails(variantId) {
    return {
      imageUrl: '/path/to/image_' + variantId + '.png',
      price: '$' + (parseInt(variantId) * 10).toFixed(2)
    };
  }

});

document.addEventListener("DOMContentLoaded", function() {
  var agreeCheckbox = document.getElementById('agree_checkbox');
  var checkoutButton = document.getElementById('checkoutBtn');
  var errorMessage = document.getElementById('error-message');

  if (errorMessage) {
    errorMessage.style.display = 'none';
    checkoutButton.addEventListener('click', function(e) {
      if (!agreeCheckbox.checked) {
        errorMessage.style.display = 'block';
        e.preventDefault();
      } else {
        errorMessage.style.display = 'none';
      }
    });
  }

  agreeCheckbox.addEventListener('change', function() {
    if (this.checked) {
      errorMessage.style.display = 'none';
    }
  });
});
// Select variant if master select include unique code
document.addEventListener('DOMContentLoaded', function() {
  const input = document.getElementById('po_customMessage');
  const select = document.querySelector('select[data-master-select]');
  if (input) {
    input.addEventListener('input', function() {
      const inputText = this.value.trim().toLowerCase();
      let found = false;

      Array.from(select.options).forEach(function(option) {
        const optionText = option.text;
        const parts = optionText.split('•');

        // if (parts.length > 1) {
        //   const textAfterBullet = parts[1].trim().toLowerCase();
        //   // if (textAfterBullet === inputText) {
        //     if (textAfterBullet.includes(inputText.toLowerCase())) {
        //     select.value = option.value;
        //     found = true;
        //   }
        // }
        if (parts.length > 1) {
          const textAfterBullet = parts[1].trim().toLowerCase();
          console.log(textAfterBullet, 'textAfterBullet')
          if (textAfterBullet === inputText) {
            select.value = option.value;
            found = true;
          }
        }



      });

      if (!found) {
        let defaultVariant = 56201931882878;
        select.value = defaultVariant;
      }
    });
  }
  if(document.querySelector("#checkout-address")) {
    const checkoutAddress = document.querySelector("#checkout-address"), checkoutTextarea = checkoutAddress.querySelector("textarea");
    document.querySelectorAll(`input[type="radio"]`).forEach((radio) => {
      radio.addEventListener('change', (event) => {
        const selectedOption1 = document.querySelector('input[name="option1"]:checked')?.value.toLowerCase(),
              selectedOption2 = document.querySelector('input[name="option2"]:checked')?.value.toLowerCase();
              
        if (selectedOption1.includes("gift box") || selectedOption2.includes("gift box")) {
          checkoutAddress.classList.remove("hidden");
          checkoutTextarea.required = true;
        } else {
          checkoutAddress.classList.add("hidden");
          checkoutTextarea.required = false;
        }
      })
    });
  }
});